// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantBoardColumnSkeleton-moduleRentalPortalApplicantBoardColumnSkeleton__aQdmQ";
var _2 = "RentalPortalApplicantBoardColumnSkeleton-modulemeta__ha9ND Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RentalPortalApplicantBoardColumnSkeleton-moduletitle__xbP12 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "RentalPortalApplicantBoardColumnSkeleton", _2 as "meta", _3 as "title" }
